module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/landing-desktop-cucarda-fuego.70152465.png";